module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/pluto/pluto_sig-b08742603db5be84f9f4650f751980f5.gif";